export default __webpack_public_path__ + "media/images/wt-paypal-d46b06d8.png";